

const Skillcard = ({ image, number, text }) => {

     
    return (
        <div className="w-[300px] h-[450px] rounded-lg bg-white/30 py-2 px-2 shadow-md shadow-white">
            <div className="w-full h-[40%] relative">
                <img src={image} alt="skillImage" className="h-full w-full rounded-t-lg" />
                <div data-aos="fade-up" className="absolute left-0 top-[50%] w-12 h-12 rounded-r-full bg-white/80 border-4 border-yellow-500 flex items-center justify-center text-center text-yellow-700 font-extrabold"><span>{number}</span><span>%</span></div>
            </div>
<div className="w-full h-[60%] flex justify-center items-center">
    <div className="py-2 px-2 text-black text-justify">
        {text}
    </div>
</div>


        </div>
    );
}

export default Skillcard;